import React, { useState, useEffect } from "react";
import { PRODUCT_BRICK_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Box,
  TableSortLabel,
  IconButton
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_BRICK_VALIDATIONS } from "../../../utils/Validation";
import AddProductBrick from "./AddProductBrick";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import {
  ProductBrickChangeStatusService,
  onEditProductBrickService,
  onAddProductBrickService,
} from "../../../services/MasterDataManagementService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const BrickList = ({
  totalElements,
  brickList,
  onSearch,
  handleTableChanges,
  setLoading,
  showNotification,
  fetchBrickListWithorWithoutFamily,
  setBrickList,
  fetchProductFamilyList,
  productFamilyList,
  noRecord,
  categoryList,
  fetchCategoryList,
}) => {
  const [searchedRows, setSearchedRows] = useState(brickList);
  const [bricknameSearch, setBrickNameSearch] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddBrickDialog, setOpenAddBrickDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [brickId, setBrickId] = useState("");
  const [formData, setFormData] = useState({});
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("brickName");
  const [sortValue, setSortValue] = useState("ASC");
  const [categoryName, setCategoryName] = useState("");
  const [selected, setSelected] = useState([]);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [diableFamilyDropdown, setDisableFamilyDropdown] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [{ auth }, dispatch] = useGlobalState();
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const loginUserId = auth.ldapParam.userId;
  const [searchValue_, setsearchValue_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });

  const formOption = {
    resolver: yupResolver(ADD_BRICK_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddBrickDialog]);

  useEffect(() => {
    
    setSearchedRows(brickList);
  }, [bricknameSearch, brickList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    setBrickNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      //await fetchBrickListWithorWithoutFamily("brickName", true);
      onclickClear();
    }
  };

  const onCategoryClick = (id, cateName) => {
    setCategoryName(cateName);
    fetchProductFamilyList(id);
    setDisableFamilyDropdown(false);
  };

  const handleClickOpenBrickDialog = () => {
    setOpenAddBrickDialog(true);
    fetchCategoryList();
  };

  const handleCloseBrickDialog = () => {
    setOpenAddBrickDialog(false);
    setIsUpdateButton(true);
    setIsEditMode(false);
    setFormData({});
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      const requestBody = {
        status: true,
        pageNumber:0,
        pageSize: rowsPerPage ?? 10,
        search: searchValue && searchValue.trim(),
      };
      setsearchValue_(searchValue)
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    // setSearchwith(type);
    setBrickNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
    
    const paginationObject = {
      pageNumber:0,
      pageSize: rowsPerPage ??10,
      };
      setSelected([]);
      setsearchValue_(null)
      setDisbaleUpdateButton(true)
    await fetchBrickListWithorWithoutFamily("brickName", false,null, null, paginationObject);
   
    setSearchValue("");
    // setRowsPerPage()
    setPage(0);
    setMaxPage(0);
    setClearSearch(false);
    setBrickNameSearch("");
    setIsSearchBtnClick(false)
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(
      paginationValues,
      false,
      sortValue,
      orderBy,
      searchValue_
    );
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(
        paginationValues,
        true,
        sortValue,
        orderBy,
        searchValue_
      );
    }
    setPage(newPage);
  };

  const onAddBrickSubmit = async (data) => {
    try {
      let obj = {
        productFamilyId: parseInt(data.productCatFamilyMappingId),
        brickName: data.brickName && data.brickName.trim(),
        brickId: brickId ? brickId : null,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.createdBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: formValues.active ? true : false,
        categoryName,
        brickCode :data.brickCode && data.brickCode.trim(),
      };
      const res = !isEditMode
        ? await onAddProductBrickService(obj)
        : await onEditProductBrickService(obj);
      if (res.statusCode === 6) {
        const newBrickList = [...brickList];
        const index = newBrickList.findIndex((x) => x.brickId === brickId);
        newBrickList[index] = { ...brickList[index], ...obj };
        setBrickList(newBrickList);
        handleCloseBrickDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);
         
        //   const timer = setTimeout(async () => {
        //     await fetchBrickListWithorWithoutFamily("brickName", true);
        //   }, 1000);
        //   return () => clearTimeout(timer);
        // }
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      throw err;
    }
  };

  const handleClickEditBrick = (item) => {
    if (item) {
      reset(item);
    }
    fetchCategoryList();
    fetchProductFamilyList(item.categoryId);
    setOpenAddBrickDialog(true);
    setIsEditMode(true);
    setBrickId(item?.brickId);
    // setBrickName(item?.brickName);
    setCategoryName(item?.categoryName);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.active ? item.active : 0,
    });
    setFormData({ ...item });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - brickList.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = brickList.map((currentRow) => {
      if (currentRow.brickId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setBrickList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = brickList.find((record) => record.brickId === itemId);
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          brickId: tempItem.brickId,
        });
      }
    });
    try {
      const res = await ProductBrickChangeStatusService(resultRecords);
      if (res.statusCode == "6") {
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationObject = {
      pageNumber: 0,
      pageSize:rowsPerPage?rowsPerPage: 10,
     
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchBrickListWithorWithoutFamily(
      property,
      isAsc,
      "null",
      searchValue_ && searchValue_.trim(),
      paginationObject
    );
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    //setSearchValue("");
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              Brick Listing ({totalElements ? totalElements : 0})
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
              
                <input
                  type="text"
                  placeholder="By brick Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                  //className="searchIcon"
                  onClick={() => searchOnClick("brickName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="brandSearchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Brick">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenBrickDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}>
                  Add Brick
                </Button>
              </Tooltip>
              <Tooltip title="Update Brick Status">
              <span>
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}>
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
                </span>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.brickId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={index}>
                              <TableCell size="small" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"brickCode"}>
                                {row["brickCode"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"categoryName"}>
                                {row["categoryName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"productFamilyName"}>
                                {row["productFamilyName"] ?? "-"}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  // checked={row.active}
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(event, row.brickId)
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell > 
                                <EditIcon
                                  sx={{ fontSize: "20px", cursor: "pointer",color:'#567aac', height: "18px", 
                                  width: "18px"  }}
                                  onClick={() => handleClickEditBrick(row)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}>
                          <TableCell colSpan={3} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={12}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={12} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddProductBrick
              openDialog={openAddBrickDialog}
              handleClose={handleCloseBrickDialog}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              productFamilyList={productFamilyList}
              onAddBrickSubmit={onAddBrickSubmit}
              formData={formData}
              isUpdateButton={isUpdateButton}
              isEditMode={isEditMode}
              setIsUpdateButton={setIsUpdateButton}
              categoryList={categoryList}
              onCategoryClick={onCategoryClick}
              diableFamilyDropdown={diableFamilyDropdown}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default BrickList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {PRODUCT_BRICK_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.brickId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
